var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5735 21.3453H12.2344L13.6974 12.5352H16.0364L14.5735 21.3453Z",
    fill: "#0742A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0557 12.7501C22.5944 12.5718 21.8626 12.375 20.9577 12.375C18.6478 12.375 17.0212 13.5746 17.0112 15.2897C16.992 16.5551 18.1758 17.2579 19.0612 17.6798C19.9662 18.111 20.2738 18.3924 20.2738 18.7767C20.2646 19.3669 19.5425 19.639 18.8691 19.639C17.9352 19.639 17.4348 19.4987 16.6744 19.1703L16.3664 19.0296L16.0391 21.0073C16.5877 21.2507 17.5984 21.4667 18.6478 21.4761C21.1022 21.4761 22.7 20.2951 22.719 18.4674C22.7283 17.4645 22.1032 16.696 20.7555 16.068C19.9374 15.6649 19.4364 15.3931 19.4364 14.9806C19.446 14.6057 19.8601 14.2216 20.7837 14.2216C21.5441 14.2028 22.1028 14.3808 22.5261 14.559L22.7376 14.6525L23.0557 12.7501Z",
    fill: "#0742A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.24 12.5352H29.0493L30.9364 21.3452H28.7706C28.7706 21.3452 28.5586 20.3329 28.4915 20.0236H25.4882C25.4014 20.2578 24.9973 21.3452 24.9973 21.3452H22.543L26.0174 13.2661C26.2581 12.6944 26.682 12.5352 27.24 12.5352ZM27.0962 15.7595C27.0962 15.7595 26.355 17.7184 26.1624 18.2245H28.1066C28.0104 17.784 27.5675 15.6752 27.5675 15.6752L27.404 14.916C27.3351 15.1115 27.2356 15.3802 27.1685 15.5615C27.1229 15.6844 27.0923 15.7671 27.0962 15.7595Z",
    fill: "#0742A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2829 12.5352L7.9921 18.5428L7.74178 17.3244C7.31827 15.9185 5.99004 14.391 4.50781 13.6315L6.60606 21.336H9.0796L12.7563 12.5352H10.2829V12.5352Z",
    fill: "#0742A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86439 12.5352H2.101L2.0625 12.7132C4.99818 13.4443 6.94243 15.2066 7.74123 17.3248L6.92311 13.2757C6.78842 12.713 6.3745 12.5537 5.86439 12.5352Z",
    fill: "#0742A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bd05c41e1c5c6d7c7463339abf09aaba.svg";
export { ForwardRef as ReactComponent };